import { DocumentModel } from './document.model'
import { PaginationModel } from './pagination.model'
import { BankaccountModel } from './bankaccount.model'

export class DocumentResponse {
  pagination: {
    total_results: number
    current_page: number
    total_pages: number
    next_page: string
    prev_page: string
    limit: number
  }
  rows: DocumentModel[]

  constructor(data) {}
}



// WEBPACK FOOTER //
// ./src/app/main/models/document-response.ts